module.exports = __webpack_public_path__ + "img/0723a036582961a6f83f80d36917e199.585b6fcb.png";